import { UniqueId } from "shared/vidio_helpers";
import PlayerEnvironment from "shared/player_environment";
import AhoyEvent from "shared/ahoy_event";

/**
 * @description playback/base.js still use this
 */
window.PlayerEnvironment = PlayerEnvironment;
export default class PlaybackBaseLoader {
  static init(baseUrl, baseCanaryUrl) {
    this._baseUrl = baseUrl;
    this._baseCanaryUrl = baseCanaryUrl;
    this._playbackId = UniqueId.get();
  }

  static getBaseUrl() {
    return this._baseUrl;
  }

  static getBaseCanaryUrl() {
    return this._baseCanaryUrl;
  }

  static getPlaybackId() {
    return this._playbackId;
  }

  static isCanary() {
    return this.params().match(/playback-canary=true/) !== null;
  }

  static params() {
    return window.location.search;
  }

  static setup() {
    if (this.isCanary()) {
      this.appendScript(this.getBaseCanaryUrl());
    } else {
      this.appendScript(this.getBaseUrl());
    }
  }

  static appendScript(scriptUrl) {
    return this.append(scriptUrl)
      .then(
        function () {
          this.sendAhoyEvent("LOADED");
        }.bind(this)
      )
      .catch(
        function () {
          this.sendAhoyEvent("FAILED");
        }.bind(this)
      );
  }

  static sendAhoyEvent(name) {
    var eventName = "PLAYBACK::BASE::" + name;
    AhoyEvent.send(eventName, this.properties());
  }

  static properties() {
    var property = {
      playback_uuid: PlaybackBaseLoader.getPlaybackId(),
      path: PlaybackBaseLoader.getPath(),
      revision: PlaybackBaseLoader.getRevisionTag(),
    };
    return Object.assign(property, PlaybackBaseLoader.env(), { embed: PlayerEnvironment.embed() });
  }

  static env() {
    return PlayerEnvironment.currentEnv();
  }

  static getRevisionTag() {
    if (
      typeof window.playback !== "undefined" &&
      typeof window.playback.Revision !== "undefined"
    ) {
      return window.playback.Revision.tag;
    }
  }

  static getPath() {
    return window.location.pathname;
  }

  static append(src) {
    return new Promise(function (resolve, reject) {
      try {
        var script = document.createElement("script");
        var body = document.getElementsByTagName("body")[0];

        script.onload = resolve;
        script.src = src;
        body.appendChild(script);

        resolve();
      } catch (e) {
        reject();
      }
    });
  }

  static configure({
    baseUrl,
    canaryBaseUrl,
    enableCustomSkipAdButtonToggle,
    enablePremierUserBannerAdsToggle,
    enableChaptersCreditTime,
    enablePrerollOnIOS,
    adsTvcSeekToLatest,
    enableAdaptivePlayerLite,
    enableSubtitleFromMasterPlaylist
  } = {}) {
    window.playback_feature_toggle = [];
    this.checkEnableCustomSkipAdButton(enableCustomSkipAdButtonToggle);
    this.checkEnablePremierUserBannerAds(enablePremierUserBannerAdsToggle);
    this.checkEnableOpenwrapPubmatic();
    this.checkEnableChaptersCreditTime(enableChaptersCreditTime);
    this.checkEnablePrerollOnIOS(enablePrerollOnIOS);
    this.checkAdsTvcSeekToLatest(adsTvcSeekToLatest);
    this.checkEnableAdaptivePlayerLite(enableAdaptivePlayerLite);
    this.checkEnableSubtitleFromMasterPlaylist(enableSubtitleFromMasterPlaylist);
    
    return this.initThenSetup(baseUrl, canaryBaseUrl);
  }

  static checkEnableSubtitleFromMasterPlaylist(enableSubtitleFromMasterPlaylist) {
    if (enableSubtitleFromMasterPlaylist == "true") {
      window.playback_feature_toggle.push(
        "enable_subtitle_from_master_playlist"
      );
    }
  }

  static checkEnableChaptersCreditTime(enableChaptersCreditTime) {
    if (enableChaptersCreditTime === "true") {
      window.playback_feature_toggle.push(
        "enable_chapters_credit_time"
      );
    }
  }

  static checkEnableCustomSkipAdButton(enableCustomSkipAdButtonToggle) {
    if (enableCustomSkipAdButtonToggle == "true") {
      window.playback_feature_toggle.push(
        "enable_custom_skip_ad_button_on_player"
      );
    }
  }

  static checkEnablePremierUserBannerAds(enablePremierUserBannerAdsToggle) {
    if (enablePremierUserBannerAdsToggle == "true") {
      window.playback_feature_toggle.push("enable_premier_user_banner_ads");
    }
  }

  static checkEnableOpenwrapPubmatic() {
    window.playback_feature_toggle.push('enable_openwrap_pubmatic');
  }

  static checkEnablePrerollOnIOS(enablePrerollAdsOnIOS) {
    if(enablePrerollAdsOnIOS === "true") {
      window.playback_feature_toggle.push("enable_preroll_on_ios");
    }
  }

  static checkAdsTvcSeekToLatest(adsTvcSeekToLatest) {
    if(adsTvcSeekToLatest === "true") {
      window.playback_feature_toggle.push("ads_tvc_seek_to_latest");
    }
  }

  static checkEnableAdaptivePlayerLite(enableAdaptivePlayerLite) {
    if(enableAdaptivePlayerLite === "true") {
      window.playback_feature_toggle.push("enable_adaptive_player_lite");
    }
  }

  static initThenSetup(baseUrl, canaryBaseUrl) {
    window.playbackProperties = this.properties;
    PlaybackBaseLoader.init(baseUrl, canaryBaseUrl);

    PlaybackBaseLoader.sendPlaybackBaseAhoyEvent();
  }

  static sendPlaybackBaseAhoyEvent() {
    const status = window.playback === undefined ? 'FAILED' : 'LOADED';
    this.sendAhoyEvent(status);
  }
}
